import { render, staticRenderFns } from "./ConsultationQuestionnaireDetails.vue?vue&type=template&id=1f918dd9&scoped=true"
import script from "./ConsultationQuestionnaireDetails.vue?vue&type=script&lang=js"
export * from "./ConsultationQuestionnaireDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsultationQuestionnaireDetails.vue?vue&type=style&index=0&id=1f918dd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f918dd9",
  null
  
)

export default component.exports